import { observer } from "mobx-react-lite";
import { useTran } from "@/hooks";
import { useCompanyStore } from "../hooks";
import { COMPANY_STEPS } from "../utils/company.steps";
import { cn } from "@/lib/utils";

const CompanySetupStepper = observer(({ canNavigateToStep, goToStep }) => {
  const { t } = useTran();
  const { step } = useCompanyStore();

  return (
    <div className="space-y-4 lg:pr-4 lg:border-r lg:border-border">
      <div className="hidden md:flex md:flex-col md:gap-2">
        {COMPANY_STEPS.map(({ id, title, icon: Icon }) => {
          const isActive = id === step;
          const isDone = id < step;
          const isDisabled = !canNavigateToStep(id);
          return (
            <button
              key={`step-${id}`}
              type="button"
              onClick={() => goToStep(id)}
              disabled={isDisabled}
              className={cn(
                "flex items-center gap-3 rounded-radius border px-3 py-2 text-left transition",
                isActive
                  ? "border-primary bg-primary/10 text-primary"
                  : isDone
                    ? "border-transparent bg-muted/60 text-foreground"
                    : "border-transparent text-muted-foreground hover:bg-muted",
                isDisabled && "cursor-not-allowed opacity-60",
              )}
            >
              <span
                className={cn(
                  "flex h-8 w-8 items-center justify-center rounded-full",
                  isActive
                    ? "bg-primary text-primary-foreground"
                    : "bg-muted text-muted-foreground",
                )}
              >
                <Icon className="h-4 w-4" />
              </span>
              <div className="flex flex-col">
                <span className="text-sm font-semibold">{t(title)}</span>
                <span className="text-xs text-muted-foreground">
                  {t("Step")} {id}
                </span>
              </div>
            </button>
          );
        })}
      </div>

      <div className="flex flex-wrap items-center justify-center gap-2 md:hidden">
        {COMPANY_STEPS.map(({ id }) => (
          <span
            key={`mobile-step-${id}`}
            className={cn(
              "flex h-7 w-7 items-center justify-center rounded-full text-sm",
              id === step
                ? "bg-primary text-primary-foreground"
                : "bg-muted text-muted-foreground",
            )}
          >
            {id}
          </span>
        ))}
      </div>
    </div>
  );
});

export default CompanySetupStepper;
